<template>
  <modal name="modalRecordAddTo"
    transition="nice-modal-fade"
    :pivotY="0.3"
    @before-open="beforeOpen"
  >
    <div class="container">
      <div class="content"><span>您希望将这段录音添加到</span></div>
      <div class="footer">
        <div class="button button--primary" @click="addAudioToScene">当前页面</div>
        <div class="button button--primary" @click="addAudioToGlobal">整个视频</div>
      </div>
      <div class="close-btn" @click="clickToClose()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      selectedRecord: null
    }
  },
  created () {

  },
  methods: {
    addAudioToScene () {
      this.$bus.emit('addAudioToScene', this.selectedRecord);
      this.addTo();
    },
    addAudioToGlobal () {
      this.$bus.emit('addAudioToGlobal', this.selectedRecord);
      this.addTo();
    },
    addTo () {
      this.$modal.hide('modalRecordAddTo');
      // this.$bus.emit('collectPersonal_vue',{data: 'collectMusicType'});
    },
    clickToClose () {
      this.$modal.hide('modalRecordAddTo');
    },
    beforeOpen ({params} = {}) {
      this.selectedRecord = params;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  min-height: 44px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  >div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/recordAddTo.vue